export const IS_ASSIGNING = 'IS_ASSIGNING'
export const IS_NOT_ASSIGNING = 'IS_NOT_ASSIGNING'
export const ASSIGN_QUEST_TO_USER_REQUEST = 'ASSIGN_QUEST_TO_USER_REQUEST'
export const ASSIGN_QUEST_TO_USER_SUCCESS = 'ASSIGN_QUEST_TO_USER_SUCCESS'
export const ASSIGN_QUEST_TO_USER_FAILURE = 'ASSIGN_QUEST_TO_USER_FAILURE'
export const IS_UNASSIGNING = 'IS_UNASSIGNING'
export const IS_NOT_UNASSIGNING = 'IS_NOT_UNASSIGNING'
export const UNASSIGN_QUEST_FROM_USER_SUCCESS =
  'UNASSIGN_QUEST_FROM_USER_SUCCESS'

import { checkHttpStatus, getApiBaseUrlWithOrg } from '../utils'
import { getErrorAction } from '../utils/actions'

export function assignmentClick() {
  return {
    type: IS_ASSIGNING
  }
}

export function assignmentCancelClick() {
  return {
    type: IS_NOT_ASSIGNING
  }
}

export function unassignmentClick() {
  return {
    type: IS_UNASSIGNING
  }
}

export function unassignmentCancelClick() {
  return {
    type: IS_NOT_UNASSIGNING
  }
}

export function assignQuestToUserRequest() {
  return {
    type: ASSIGN_QUEST_TO_USER_REQUEST
  }
}

export function assignQuestToUserSuccess(response, questId, currentUser) {
  return {
    type: ASSIGN_QUEST_TO_USER_SUCCESS,
    payload: {
      assignment: response,
      questId: questId,
      currentUser: currentUser
    }
  }
}

export function assignQuestToUserFailure(error) {
  return getErrorAction(ASSIGN_QUEST_TO_USER_FAILURE, error)
}

export function unassignQuestFromUserSuccess(assignedToCurrentUser) {
  return {
    type: UNASSIGN_QUEST_FROM_USER_SUCCESS,
    assignedToCurrentUser: assignedToCurrentUser
  }
}

export function assignQuestToUser(
  assignedToId,
  assignmentMessage,
  questId,
  currentUser
) {
  return async (dispatch, getState) => {
    dispatch(assignQuestToUserRequest())

    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/assignments`
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'POST',
          headers: {
            Authorization: `Token token="${state.user.token}"`,
            Accept: 'application/json, application/vnd.oefngl.v1',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            assignment: {
              assigned_to_id: assignedToId,
              message: assignmentMessage
            }
          })
        })
      )
      const json = await response.json()
      dispatch(assignQuestToUserSuccess(json, questId, currentUser))
    } catch (error) {
      dispatch(assignQuestToUserFailure(error))
    }
  }
}

export function unassignQuestFromUser(
  questId,
  assignedToCurrentUser,
  assignmentId
) {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/assignments/${assignmentId}`
    try {
      checkHttpStatus(
        await fetch(url, {
          method: 'DELETE',
          headers: {
            Authorization: `Token token="${state.user.token}"`,
            Accept: 'application/json, application/vnd.oefngl.v1'
          }
        })
      )

      dispatch(unassignQuestFromUserSuccess(assignedToCurrentUser))
    } catch (error) {
      console.log(error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/assignment.js